// src/firebase.js
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  setPersistence, 
  indexedDBLocalPersistence
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBGC1XWYLnrCMFuAtHHLLRnTHCIC42vjc4",
  authDomain: "pitazo-mundial.firebaseapp.com", // ✅ CORREGIDO — dominio original Firebase
  projectId: "pitazo-mundial",
  storageBucket: "pitazo-mundial.firebasestorage.app",
  messagingSenderId: "356532252970",
  appId: "1:356532252970:web:23824e8508c843b077ae53"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Persistencia IndexedDB (más robusta en app nativa)
setPersistence(auth, indexedDBLocalPersistence)
  .then(() => console.log("✅ Persistencia configurada"))
  .catch(console.warn);